const StatCard = ({ title, value, className = '' }) => {
  return (
    <div className={`bg-white p-4 rounded-lg shadow flex flex-col text-center ${className}`}>
      <span className="text-sm text-gray-500">{title}</span>
      <span className="text-2xl font-bold mt-2">{value}</span>
    </div>
  );
};

export default StatCard;